import React from 'react';
function Icon(props) {
  if (props?.size == 'sm') {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 -960 960 960">
        <path fill={props.fill || '#1D252D'} d="M250.77-779.84h452.15v439.99L429.54-68l-15.84-5.85q-17.24-12.23-25.35-30.5-8.12-18.27-3.12-37.34v3.84l36.47-202H132.31q-26.54 0-45.42-18.88Q68-377.62 68-404.15v-41.62q0-7.23 1.31-12.96t3.92-11.96l113.62-267.46q7.61-19.23 25.34-30.46t38.58-11.23m504.15 439.99v-439.99H892v439.99z"></path>
      </svg>;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M250.77-803.84h396.15v479.99L381.54-60 347.7-93.85q-6.24-6.23-10.35-16.5-4.12-10.27-4.12-19.34v-10.16l42.47-184H132.31q-28.54 0-50.42-21.88Q60-367.62 60-396.15v-64.62q0-6.23 1.31-13.46t3.92-13.46l114.62-270.46q8.61-19.23 28.84-32.46t42.08-13.23m456.15 479.99v-479.99H860v479.99z"></path>
    </svg>;
}
export default Icon;